var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "add-order",
    attrs: {
      title: _vm.$t("添加订单数据"),
      visible: _vm.addVisible,
      width: 620
    },
    on: {
      ok: _vm.saveAdd,
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品"),
      prop: "production"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label"
    },
    on: {
      change: _vm.productionChange
    },
    model: {
      value: _vm.addForm.production,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "production", $$v);
      },
      expression: "addForm.production"
    }
  }, _vm._l(_vm.productionSelectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(_vm._s(item.name) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("用户"),
      prop: "user"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label"
    },
    model: {
      value: _vm.addForm.user,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "user", $$v);
      },
      expression: "addForm.user"
    }
  }, _vm._l(_vm.userSelectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.nickName
      }
    }, [_vm._v(_vm._s(item.nickName) + "      "), _c("span", {
      staticStyle: {
        color: "#999999"
      }
    }, [_vm._v(_vm._s(item.structureLevel))])]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式"),
      prop: "payment"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.payment,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "payment", $$v);
      },
      expression: "addForm.payment"
    }
  }, _vm._l(_vm.paymentSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付状态"),
      prop: "payState"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.payState,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "payState", $$v);
      },
      expression: "addForm.payState"
    }
  }, _vm._l(_vm.payStateSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单号"),
      prop: "number"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.number,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "number", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.number"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };